export const historicalGrowthDataSelector = (state) => ({
  historicalGrowthData: state.historicalGrowth.data,
});

export const averageAnnualGrowthMetricsSelector = (state) => ({
  averageAnnualGrowthMetrics: state.historicalGrowth.metrics.averageAnnualGrowthMetrics,
});
